// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useTenantStore } from "@/providers/TenantContextProvider";
import { useContext } from "react";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
export function useAreaPermissions() {
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    /**
     * Permissions
     */
    var canCreateArea = authContext.isAuthorized(true, tenantId, IPermissions.AREA_CREATE);
    var canEditArea = authContext.isAuthorized(true, tenantId, IPermissions.AREA_WRITE);
    var canReadArea = authContext.isAuthorized(true, tenantId, IPermissions.AREA_READ);
    var canDeleteArea = authContext.isAuthorized(true, tenantId, IPermissions.AREA_DELETE);
    var canImportArea = authContext.isAuthorized(true, tenantId, IPermissions.AREA_IMPORT);
    var canExportArea = authContext.isAuthorized(true, tenantId, IPermissions.AREA_EXPORT);
    var canUpsertArea = authContext.isAuthorized(true, tenantId, IPermissions.AREA_UPSERT);
    var showAreaColumns = authContext.isAuthorized(true, tenantId, IPermissions.EE_AREAS_COLUMNS);
    var showAreaFilters = authContext.isAuthorized(true, tenantId, IPermissions.EE_AREAS_FILTERS);
    /**
     * Permissions
     */
    return {
        canCreateArea: canCreateArea,
        canEditArea: canEditArea,
        canReadArea: canReadArea,
        canDeleteArea: canDeleteArea,
        canImportArea: canImportArea,
        canExportArea: canExportArea,
        canUpsertArea: canUpsertArea,
        showAreaColumns: showAreaColumns,
        showAreaFilters: showAreaFilters,
    };
}
